import React, {useEffect, useCallback} from 'react';
import {CurrenciesDropdown} from '../CurrenciesDropdown/CurrenciesDropdown';
import {IPropsInjectedByViewerScript} from '../../viewerScript/currencyConverterStore';
import {isExperimentEnabled} from '../../utils/experiments.utility';
import {FEATURE_FLAGS} from '../../../settings/constants/featureFlags';

export const CurrencyConverterApp = (props: IPropsInjectedByViewerScript) => {
  const {
    userCurrencies,
    currencySymbols,
    selectedCurrency,
    onCurrencySelected,
    translations,
    isRtl,
    isMobile,
    host,
    onAppLoaded,
    reportAppNotLoaded,
    experiments,
    suggestedCurrencyCode,
    suggestedCurrencyAutoSwitchEnabled,
    biParams,
    queryCurrency,
    onBIEvent,
  } = props;

  const reportAppLoaded = useCallback(() => {
    /* istanbul ignore next: hard to test it */
    if (selectedCurrency && typeof onAppLoaded === 'function') {
      onAppLoaded();
    } else {
      reportAppNotLoaded(selectedCurrency, onAppLoaded);
    }
  }, [selectedCurrency, onAppLoaded, reportAppNotLoaded]);

  useEffect(() => {
    host.registerToComponentDidLayout(reportAppLoaded);
  }, [host, reportAppLoaded]);

  const isPopoverWithSuggestCurrencyEnabled = isExperimentEnabled(
    experiments,
    FEATURE_FLAGS.suggestLocalCurrencyForConverter
  );

  const shouldShowSuggestCurrency =
    props.shouldShowSuggestCurrency ??
    props?.host?.style?.styleParams.booleans.currencyConverter_shouldShowSuggestCurrency ??
    true;

  const shouldUseAutoCurrencySwitch =
    props.shouldUseAutoCurrencySwitch ??
    props?.host?.style?.styleParams.booleans.currencyConverter_shouldUseAutoCurrencySwitch ??
    true;

  return (
    <CurrenciesDropdown
      shouldShowSuggestCurrency={shouldShowSuggestCurrency && isPopoverWithSuggestCurrencyEnabled}
      shouldUseAutoCurrencySwitch={shouldUseAutoCurrencySwitch}
      currencySymbols={currencySymbols}
      currencies={userCurrencies}
      onChange={onCurrencySelected}
      queryCurrency={queryCurrency}
      selectedCurrency={selectedCurrency}
      translations={translations}
      isRtl={isRtl}
      isMobile={isMobile}
      suggestedCurrencyCode={suggestedCurrencyCode}
      suggestedCurrencyAutoSwitchEnabled={suggestedCurrencyAutoSwitchEnabled}
      biParams={biParams}
      onBIEvent={onBIEvent}
    />
  );
};
